import { render, staticRenderFns } from "./UploadingForm.vue?vue&type=template&id=07a77f14&scoped=true&"
import script from "./UploadingForm.vue?vue&type=script&lang=js&"
export * from "./UploadingForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadingForm.vue?vue&type=style&index=0&id=07a77f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a77f14",
  null
  
)

export default component.exports